export default __webpack_public_path__ + "static/dekorasi-e8bebd0aa8e0fdc137ff48691c57b336.png";